import { useInView as useInViewHook } from 'react-intersection-observer';

export default function useInView(options) {
  return useInViewHook(options);
}
